var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"card-image",attrs:{"src":_vm.image}}),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.name))]),_c('img',{attrs:{"src":_vm.rightArrowIcon}})])])}
var staticRenderFns = []

export { render, staticRenderFns }